import { defineStore } from 'pinia';

export interface UTMState {
  source: string | null;
  medium: string | null;
  campaign: string | null;
  term: string | null;
  content: string | null;
}

export const useUTMStore = defineStore('utm', {
  state: (): UTMState => ({
    source: 'yrxd_web', // 该参数同时作为流量来源追踪及渠道标识符
    medium: '',
    campaign: '',
    term: '',
    content: '',
  }),
  actions: {
    update(payload: Partial<UTMState>) {
      this.source = payload.source ?? 'yrxd_web';
      this.medium = payload.medium ?? this.medium;
      this.campaign = payload.campaign ?? this.campaign;
      this.content = payload.content ?? this.content;
      this.term = payload.term ?? this.term;
    },
  },
});
